import { useEffect, useRef, useState } from "react";
import { Button, Popconfirm, Table, Tooltip } from "antd";
import { ErrorToast, SuccessToast } from "../../../widgets/AppToast";
import { post } from "../../../services/services";
import { ApiURL } from "../../../services/apiConstants";
import StatusTag from "../../../components/StatusTag";
import LogbookModal from "../../../components/LogbookModal";
import { CheckCircleOutlined } from "@ant-design/icons";

const PaidSubscriptionList = () => {
  const calledOnce = useRef(false);
  const [page_loader, set_page_loader] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [visible, setVisible] = useState(false);
  const [companyId, setCompanyId] = useState(null);

  const handleSave = (selectedItem) => {
    if (!selectedItem?.duration) {
      alert("Please select subscription duration");
      return;
    }
    const logbookIds = (selectedItem.logbooks || []).map((book) => book.id);
    const formData = new FormData();
    formData.append("company_id", companyId);
    logbookIds.forEach((id) => {
      formData.append("logbook_ids[]", id);
    });
    formData.append("months", selectedItem.duration);
    post(ApiURL.assign_logbooks, formData)
      .then((res) => {
        if (res?.status === true) {
          SuccessToast("Success", res?.message);
          setVisible(false);
          PAID_SUBSCRIPTION_LIST();
        } else {
          ErrorToast("Error", res?.message);
        }
      })
      .catch((err) => {
        console.error("API Error:", err);
        ErrorToast("Error", "Something went wrong. Please try again.");
      });
  };

  const PAID_SUBSCRIPTION_LIST = () => {
    set_page_loader(true);
    try {
      const FORM_DATA = new FormData();
      post(ApiURL.paid_subscription_list, FORM_DATA).then((res) => {
        if (res?.status == true) {
          setFilteredData(res?.data);
        } else {
          set_page_loader(false);
        }
      });
    } catch (error) {
      console.error("Error fetching ship list:", error);
    } finally {
      set_page_loader(false);
    }
  };

  const PAID_COMPLETE_REQUEST_API = (company_id) => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("company_id", company_id);
      post(ApiURL.paid_complete_request, FORM_DATA).then((res) => {
        if (res?.status == true) {
          SuccessToast("Success", res?.message);
          PAID_SUBSCRIPTION_LIST();
        } else {
          ErrorToast("Error", res?.message);
        }
      });
    } catch (error) {
      console.error("Error changing company status:", error);
    } finally {
    }
  };

  useEffect(() => {
    if (!calledOnce.current) {
      PAID_SUBSCRIPTION_LIST();
      calledOnce.current = true;
    }
  }, []);

  const columns = [
    {
      title: "Company Name",
      dataIndex: "company_name",
      align: "center",
      key: "company_name",
    },
    {
      title: "Email",
      dataIndex: "company_email",
      align: "center",
      key: "company_email",
    },

    {
      title: "Country",
      dataIndex: "country",
      align: "center",
      key: "country",
    },

    {
      title: "Demo Status",
      dataIndex: "all_status",
      align: "center",
      key: "all_status",
      render: (all_status) => (
        <StatusTag status={all_status ? all_status : ""} />
      ),
    },
    {
      title: "Trial Status",
      dataIndex: "trial_status",
      align: "center",
      key: "trial_status",
      render: (trial_status) => (
        <StatusTag status={trial_status ? trial_status : ""} />
      ),
    },
    {
      title: "Paid subscription Status",
      dataIndex: "paid_status",
      align: "center",
      key: "paid_status",
      render: (paid_status) => (
        <StatusTag status={paid_status ? paid_status : ""} />
      ),
    },
    {
      title: "Paid Start At",
      dataIndex: "paid_start_at",
      align: "center",
      key: "paid_start_at",
      render: (text, record) =>
        new Date(record?.paid_start_at).toLocaleString(),
    },
    {
      title: "Paid End At",
      dataIndex: "paid_end_at",
      align: "center",
      key: "paid_end_at",
      render: (text, record) => new Date(record?.paid_end_at).toLocaleString(),
    },
    {
      title: "Action",
      align: "center",
      key: "action",
      render: (text, record) => (
        <>
          {record.paid_status == 1 || null ? (
            <Tooltip title="Paid Subscription">
              <Button
                type="primary"
                size="small"
                style={{ marginRight: "10px" }}
                icon={<CheckCircleOutlined />}
                onClick={() => {
                  setVisible(true);
                  setCompanyId(record?.id);
                }}
              />
            </Tooltip>
          ) : record.paid_status == 2 ? (
            <Popconfirm
              title="Subscription completion"
              description={`Are you sure you want to complete the subscription for "${record.company_name}"?`}
              onConfirm={() => PAID_COMPLETE_REQUEST_API(record?.id)}
              okText="Yes"
              cancelText="No"
            >
              <Tooltip title="Subscription completion">
                <Button
                  type="primary"
                  size="small"
                  icon={<CheckCircleOutlined />}
                />
              </Tooltip>
            </Popconfirm>
          ) : null}
        </>
      ),
    },
  ];

  return (
    <>
      <div>
        <div className="row" style={{ padding: "10px" }}>
          <div
            className="col-3"
            style={{ marginLeft: "5px", alignSelf: "end" }}
          >
            <div className="theme-content-title text-left">
              <h3>Paid Subscription List</h3>
            </div>
          </div>
          <div className="col-3"></div>
        </div>
        <Table
          bordered
          columns={columns}
          dataSource={filteredData}
          pagination={{ pageSize: 10 }}
          rowKey="key"
          loading={page_loader}
          className="custom-table"
        />
      </div>
      {/* <LogbookModal
        // company_id={companyId}
        companyId={companyId} 
        visible={visible}
        onClose={() => setVisible(false)}
        onSave={handleSave}
      /> */}
      <LogbookModal
  companyId={companyId}
  visible={visible}
  onClose={() => setVisible(false)}
  refreshList={PAID_SUBSCRIPTION_LIST}
/>
    </>
  );
};

export default PaidSubscriptionList;
